import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres33u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres33u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres33u/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_typ + '/' + searchParams.p_codempid + '/' + searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres33u/detail/' + params)
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres33u/sendApprove', sendParams)
  },
  postSubmit () {
    if (isMock) return generator(mocker.detail())
    return instance().post(endpoint + '/hres33u/submit')
  }
}



// WEBPACK FOOTER //
// ./src/api/hres33u/index.js